import { connect } from 'react-redux';
import { UserAuthCallbackEvents } from './events';
import { IUserAuthCallbackEvents, IUserAuthCallbackFields } from '../components/types';
import { UserAuthCallback } from '../components/UserAuthCallback';
import { IState } from '../../../store/types';

const mapStateToProps = (
  dispatch: any
) => {
  return (
    state: IState
  ): IUserAuthCallbackFields => {
    return {

    }
  };
}

const mapDispatchToProps = (
  dispatch: any
): IUserAuthCallbackEvents => ({
    onLoad: code => dispatch(UserAuthCallbackEvents.onLoad(code))
  }
);

export const UserAuthCallbackHOC = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAuthCallback);

UserAuthCallbackHOC.displayName = 'UserAuthCallbackHOC';
